import React, { createContext } from 'react'

import type { KinerjaProfil } from 'types/kinerja'
import type { School, Schools } from 'types/kinerja-ks'

interface Data {
  id: School['npsn'] | null
  profile: KinerjaProfil
  isProfileFetched: boolean
  isLoadingProfile: boolean
  userHasPltRole: boolean
  isAutoSelectSchool: boolean
  schools: Schools
  selectedSchool: School | null
  selectedSchoolName: School['schoolName'] | string | null
  currentNpsn: School['npsn'] | null

  isLoadingSchools?: boolean
  isFailedLoadingSchools?: boolean
  refetchSchools?: () => void
  isNpsnValid: boolean | string
}

export const SchoolContext = createContext<Data>({
  id: null,
  profile: null,
  isProfileFetched: false,
  isLoadingProfile: false,
  userHasPltRole: false,
  isAutoSelectSchool: false,
  schools: [],
  selectedSchool: null,
  selectedSchoolName: null,
  currentNpsn: null,
  isNpsnValid: false,
})

export default function useSchoolContext() {
  const context = React.useContext(SchoolContext)

  if (!context)
    throw new Error('useSchoolContext must be used within a SchoolContext')

  return context
}
